import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import accessoLogo from '../../assets/accesso-logo.png';
import logo from '../../assets/1Risk-Calibri-Final-1097x400.png';
import './Header.css';

const Header = () => {
  const { user } = useAuth();
  const companyName = user?.preferences?.companyName;
  const fullTitle = companyName ? `${companyName} User Portal` : 'Portal';

  return (
    <header className="header">
      <div className="header-left">
        <img src={logo} alt="1RISK" className="header-logo" />
      </div>
      <h1 className="header-title header-title--full">{fullTitle}</h1>
      <h1 className="header-title header-title--short">User Portal</h1>
      <div className="header-right">
        <img src={accessoLogo} alt="accesso" className="header-accesso-logo" />
      </div>
    </header>
  );
};

export default Header;
